<div class="reserve-loading-container">
  @if (!isTimeout) {
  <img width="28" height="28" ngSrc="assets/img/img-loadingAI.png" alt="Loading Image" class="loading-image" />
  <h2>{{ 'reserve-loading.message' | translate }}</h2>
  <br>
  <!-- 倒數中：顯示動畫圓點 + 倒數秒數 -->
  <div class="dot-loader">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <p class="countdown-text">
    同時在線使用人數過多， 預估等待時間
    <span class="countdown-number">{{ countdown }}</span> 秒
  </p>
  }

  <!-- 超時：顯示提示文字 + 重新整理按鈕 -->
  @if (isTimeout) {
  <p class="timeout-text"> 同時在線使用人數過，請點選下方按鈕重新嘗試</p>
  <br>
  <button class="btn-refresh" (click)="retry()">再試一次</button>
  }
</div>